import React from 'react';
import { HeroCTAButton } from './HeroCTAButton';
export function HeroSection() {
  return <section className="relative bg-navy-dark pt-0 pb-16 md:pb-24 overflow-hidden" data-id="element-57">
      {/* Urgency Bar */}
      <div className="bg-gold-primary text-navy-dark py-3 px-4 text-center font-bold text-sm md:text-base tracking-wide z-20 relative shadow-md" data-id="element-58">
        ⚠️ FECHA LÍMITE: Abril 2026 — Después pierdes tu derecho a reclamar
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 md:pt-20 relative z-10" data-id="element-59">
        <div className="text-center space-y-8" data-id="element-60">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight drop-shadow-lg" data-id="element-61">
            ¿Hiciste tus taxes de 2022, 2023 o 2024? El IRS podría tener un
            cheque de hasta <span className="text-gold-primary" data-id="element-62">$1,800</span>{' '}
            con tu nombre... y solo tienes hasta abril para reclamarlo.
          </h1>

          <h2 className="text-xl md:text-2xl text-gold-secondary font-medium max-w-3xl mx-auto leading-relaxed" data-id="element-63">
            Descubre los 6 "Hacks" legales que los preparadores de impuestos no
            te cuentan y que me permitieron pasar de un reembolso de $3,500 a
            uno de $8,500 de forma 100% legal.
          </h2>

          <div className="pt-8 pb-4 flex justify-center" data-id="element-64">
            <div className="relative w-full max-w-md mx-auto" data-id="element-65">
              <div className="absolute inset-0 bg-gold-primary/20 blur-3xl rounded-full" data-id="element-66"></div>
              <img src="https://cdn.magicpatterns.com/uploads/kXZb6WKQccBwBBMFTfWPkt/irsTeDebe.png" alt="El Dinero Que El IRS Te Debe - Guía Experta de Declaración" className="relative z-10 w-full h-auto drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-67" />
            </div>
          </div>

          <div className="pt-6" data-id="element-68">
            <HeroCTAButton data-id="element-69" />
            <p className="mt-4 text-sm text-gray-400 font-medium" data-id="element-70">
              Acceso inmediato • Pago 100% seguro
            </p>
          </div>
        </div>
      </div>

      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[500px] opacity-20 pointer-events-none" data-id="element-71">
        <div className="absolute inset-0 bg-gradient-to-b from-navy-light to-transparent rounded-full blur-3xl" data-id="element-72"></div>
      </div>
    </section>;
}